import React from "react";
import Link from "next/link";
import { IoIosArrowRoundForward } from "react-icons/io";

import { Container, Row, Col } from "../Base/Layout";
import PageHeader from "../Base/PageHeader";

import { BlogPageWrapper } from "./blogList.style";

const getMonth = (date) => date.toLocaleString('default', { month: 'short' })

const BlogList = ({posts}) => {
  return (
    <BlogPageWrapper>
      <PageHeader title="Blog List" />
      <div className="blog-list-wrapper">
        <Container>
          <Row>
            <Col sm={12} md={8} style={{margin: '0 auto'}}>
              <Row>
                {posts.map((post, index) => 
                  <Col key={index} xs={12}>
                    <div className="post-block list">
                      <div className="post-thumb-block">
                        <div className="post-meta">
                          <span>
                            <em> {post.data.date.getDate()} </em> {getMonth(post.data.date).toUpperCase()}
                          </span>
                        </div>
                      </div>
                      <h2 className="post-title">
                        <Link href={`/blog/${post.slug.toLowerCase()}`}>
                          {post.data.title}
                        </Link>
                      </h2>
                      <p className="post-entry">
                        {post.data.description ?? 'No description'}
                      </p>

                      <Link href={`/blog/${post.slug.toLowerCase()}`} className="readmore-btn">
                        <span style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>see more <IoIosArrowRoundForward /></span>
                      </Link>
                    </div>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </BlogPageWrapper>
  );
};

export default BlogList;
